import { Header } from "components/global";
import { BottomNavbar } from "components/pages/customer";
import { useSession } from "next-auth/react";
import PropTypes from "prop-types";
import { FaHome, FaBell, FaGavel, FaBriefcase, FaBook } from "react-icons/fa";
import CustomerNavbar from "./customer-navbar";
import { useCallback, useEffect, useState } from "react";
import DialogAuth from "components/DialogAuth";
import useCallStore from "store/useCallStore";

function CustomerLayout({ children, showMobileHeader = false }) {
  const { data: session, status } = useSession();
  const setPeerUser = useCallStore(state => state.setPeerUser);
  const full_name = session?.user?.full_name || "";
  const avatar = session?.user?.avatar || "";
  const [authDialogOpen, setAuthDialogOpen] = useState(false);

  useEffect(() => {
    if (session?.user) {
      setPeerUser({
        userId: session.user.id,
        userName: session.user.full_name,
        userType: session.user.role,
        avatar: session.user.avatar,
      })
    }
  }, [session, setPeerUser]);


  const protectedRoutes = [
    "/customer/notifications",
    "/customer/bookings?status=upcoming",
    // "/customer/services",
  ];

  const handleProtectedRouteClick = useCallback((e, href) => {
    if (status !== "authenticated" && protectedRoutes.includes(href)) {
      e.preventDefault();
      setAuthDialogOpen(true);
    } else {
      setAuthDialogOpen(false);
    }
  }, [status, protectedRoutes]);

  const navItems = [
    { title: "الرئيسية", icon: <FaHome />, href: "/customer" },
    {
      title: "الحجوزات",
      icon: <FaBook />,
      href: "/customer/bookings?status=upcoming",
    },
    {
      title: "خدماتي",
      icon: <FaBriefcase />,
      href: "/customer/services",
    },
    {
      title: "المحامين",
      icon: <FaGavel />,
      href: "/customer/lawyers",
    },
    {
      title: "الإشعارات",
      icon: <FaBell />,
      href: "/customer/notifications",
    },
  ];
  return (
    <div className="min-h-screen flex flex-col justify-between">
      <DialogAuth open={authDialogOpen} setOpen={setAuthDialogOpen} />
      <div className="pb-20 md:pb-10">

        {/* Mobile Header */}
        {showMobileHeader && (
          <div className="md:hidden">
            <Header
              title={full_name ? `مرحبا أ, ${full_name}` : "مرحبا بك"}
              image={avatar || "/tqneen/default-user.jpg"}
              isRow
              setAuthDialogOpen={setAuthDialogOpen}
            />
          </div>
        )}
        {/* Desktop Navbar */}
        <CustomerNavbar
          navItems={navItems}
          full_name={full_name}
          avatar={avatar || "/tqneen/default-user.jpg"}
          isAuthenticated={status === "authenticated"}
          handleProtectedRouteClick={handleProtectedRouteClick}
          setAuthDialogOpen={setAuthDialogOpen}
        />

        <div className="container">
          {children}
        </div>
      </div>
      <div className="md:hidden">
        <BottomNavbar navItems={navItems} handleProtectedRouteClick={handleProtectedRouteClick} />
      </div>
    </div>
  );
}

CustomerLayout.propTypes = {
  children: PropTypes.node.isRequired,
  showMobileHeader: PropTypes.bool,
};

export default CustomerLayout;